import TextView from "./TextView";

export default TextView;
